import React, { useState } from "react";
import "./MediaSection.css";


const mediaItems = [
    {
        title: "World Schools",
        text: `Techno India Group World Schools are elite institutions of academic excellence, aimed at shaping global citizens of tomorrow with compassion. While ensuring world-class education, these abodes of modern learning also uphold core values like morality, humility and empathy towards society. Functioning with a holistic approach towards development, the knowledge centres facilitate students in honing their co-scholastic skills too.`,
        image: "/images/education/college.jpg",
        link: "#",
    },
    {
        title: "Public Schools",
        text: `Techno India Group Public Schools are premier institutions of academic excellence,
where educational brilliance goes hand in hand with holistic growth. This legacy chain of
schools, remains dedicated to empowering students with inquisitiveness, the zeal to learn
new things, critical thinking and adaptability with the fast-changing, tech-first knowledge
landscape. The meticulously curated curriculum amalgamates state-of-the-art academic
facilities and top-notch faculty, with co-curricular development and community
engagement. ​`,
        image: "/images/education/school.jpg",
        link: "#",
    },
    {
        title: "Colleges",
        text: `Techno India Group has made a name for itself in the academic heatmap of India and its
illustrious list of colleges, is a hallmark of the significant impact the educational
behemoth has made in the country’s higher education landscape. Ever since starting out
with Netaji Subhash Engineering College (NSEC) in the late-’90s, there has been no
looking back. Today, we take pride in the six engineering and management colleges,
whose standout alumni is spread across the globe. ​`,
        image: "/images/education/college.jpg",
        link: "#",
    },

    {
        title: "Universities",
        text: `In order to provide students with tailored pathways to launch dream careers and
facilitate advanced research, Techno India Group built the Sister Nivedita University
(SNU) in 2017. This timely move was followed by the inception of the Techno India
University, Tripura (TIUT) in 2023, as we expanded our decorated academic journey
beyond the state. Cut to 2026, SNU stands out as a jewel in TIG’s coveted crown and
TIUT is adding significant value to research and innovation, in the state of Tripura. ​`,
        image: "/images/education/university.jpg",
        link: "#",
    },

];


export default function MediaSection() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(null);

    const changeBG = (index) => {
        if (index === activeIndex) return;

        setNextIndex(index);

        setTimeout(() => {
            setActiveIndex(index);
            setNextIndex(null);
        }, 600);
    };

    const activeItem = mediaItems[activeIndex];
    const nextItem =
        nextIndex !== null ? mediaItems[nextIndex] : null;

    return (
        <section className="media-wrapper">

            <div className="media-top">
                <div className="ecosystem-top">
                    Our Ecosystem
                </div>
            </div>
            <div className="media-top">
                <h2>Education</h2>

                <a href="/education" className="learn-more">
                    <i className="bi bi-arrow-right-circle-fill"></i>
                    Learn more
                </a>
            </div>

            <div className="media-section-eco">

                <div
                    className="media-bg"
                    style={{
                        backgroundImage: `url(${activeItem.image})`,
                    }}
                />

                {nextItem && (
                    <div
                        className="media-bg media-bg-next"
                        style={{
                            backgroundImage: `url(${nextItem.image})`,
                        }}
                    />
                )}

                <div className="overlay"></div>

                <div className="media-inner container">

                    <div className="media-menu">
                        {mediaItems.map((item, i) => (
                            <div
                                key={i}
                                className={`media-menu-item ${activeIndex === i ? "active" : ""}`}
                                onMouseEnter={() => changeBG(i)}
                            >
                                {item.title}
                            </div>
                        ))}
                    </div>

                    <div className="media-content">
                        <h3>{activeItem.title}</h3>

                        <div className="media-text-box">
                            <p>{activeItem.text}</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}
